<h4 mat-dialog-title>
  {{ (dialogData?.header ? dialogData.header : "base.confirm") | translate }}
</h4>

@if (dialogData?.text) {
  <p>{{ dialogData.text | translate }}</p>
}

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    color="secondary"
    (click)="onClose()"
    data-testid="confirm-dialog-no"
  >
    {{ "base.no" | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    (click)="onConfirm()"
    data-testid="confirm-dialog-yes"
  >
    {{ "base.yes" | translate }}
  </button>
</mat-dialog-actions>
